import { render, staticRenderFns } from "./FerryName.vue?vue&type=template&id=eb79e45e&"
import script from "./FerryName.vue?vue&type=script&lang=js&"
export * from "./FerryName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports